<template>
    <v-row>
        <v-col cols="12">
            <div class="title-label">
                {{ $t('entrance.sport_record') }}
            </div>
            <div class="label" v-if="stepperMode">
                {{ $t('entrance.first_weighing') }}
            </div>
        </v-col>
        <v-col cols="12" v-if="stepperMode">
            <kimsa-slider
                :label="$t('entrance.height')"
                units="cm"
                :labels-interval="10"
                :step="1"
                :min="100"
                :max="200"
                @change="height = $event"
                :value="height"
                ref="height"
            />
        </v-col>
        <v-col cols="12" class="py-6" v-if="stepperMode">
            <kimsa-slider
                :label="$t('entrance.weight')"
                units="kg"
                :labels-interval="10"
                :step="1"
                :min="40"
                :max="140"
                @change="weight = $event"
                :value="weight"
                ref="weight"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-slider
                :label="$t('entrance.training_days')"
                units=""
                :labels-interval="1"
                :step="1"
                :min="0"
                :max="7"
                @change="trainingDays = $event"
                :value="trainingDays"
                ref="weight"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-combobox
                color="secondary"
                :label="$t('entrance.trained_sport')"
                :items="sportOptions"
                :placeholder="$t('entrance.search_sport')"
                @change="sportSelected = $event"
                :value="sportSelected"
                ref="sport"
            />
        </v-col>
    </v-row>
</template>

<script>
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import KimsaSlider from "@/components/common/inputs/KimsaSlider";
import {mapActions, mapState} from "vuex";

export default {
    name: "SportRecord",
    components: {KimsaSlider, KimsaCombobox},
    props: {
        stepperMode: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            height: 160,
            weight: 60,
            trainingDays: 0,
            sportSelected: '',
        }
    },
    computed: {
        ...mapState(['config']),
        sportOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.sports.map(sport => ({name: sport, value: sport}))
        },
        form(vm = this) {
            if(vm.stepperMode) return {
                height: vm.height,
                weight: vm.weight,
                trainingDays: Number(vm.trainingDays),
                sportSelected: vm.sportSelected,
            }

            return {
                trainingDays: Number(vm.trainingDays),
                sportSelected: vm.sportSelected,
            }
        },
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadSportRecord()
    },
    methods: {
        ...mapActions(['bindConfig']),
        loadSportRecord() {
            const vm = this
            vm.height = vm.account?.height || 160
            vm.weight = vm.account?.weight || 60
            vm.trainingDays = Number(vm.account?.trainingDays || 0)
            vm.sportSelected = vm.account?.sportSelected || ''
        }
    },
    watch: {
        account() {
            this.loadSportRecord()
        },
        form(val) {
            this.$emit('change', val)
        },
    }
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}

.label {
    font-size: 15px;
    color: #707070;
    margin-top: 8px;
}

</style>